(() => {
 'use strict';
 // Theme Editor reloads may execute this asset again; retain one lifecycle owner.
 if (window.yndSignatureCarouselInitialized) return;
 window.yndSignatureCarouselInitialized = true;
 const instances = new Map();
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
 let keyboardInput = true;
 document.addEventListener('keydown', () => { keyboardInput = true; }, true);
 document.addEventListener('pointerdown', () => { keyboardInput = false; }, true);
 function initialize(carousel) {
  if (instances.has(carousel)) return;
  let destroyed = false;
  const cleanups = [];
  const listen = (target, type, callback, options) => {
   target.addEventListener(type, callback, options);
   cleanups.push(() => target.removeEventListener(type, callback, options));
  };
  const observe = (Observer, target, callback, options) => {
   const observer = new Observer((...args) => { if (!destroyed) callback(...args); });
   observer.observe(target, options);
   cleanups.push(() => observer.disconnect());
  };
  const track = carousel.querySelector('[data-carousel-track]');
  const previous = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  const progress = carousel.querySelector('[data-carousel-progress]');
  const status = carousel.querySelector('[data-carousel-status]');
  const toggle = carousel.querySelector('[data-carousel-autoplay]');
  if (!track || !previous || !next || !progress || !status) return;
  const cards = [...track.children];
  const originalState = cards.map(card => ({inert:card.inert, hidden:card.getAttribute('aria-hidden')}));
  if (!cards.length) return;
  const direction = carousel.dataset.autoplayDirection === 'right' ? -1 : 1;
  const slots = [];
  const copies = cards.map(() => []);
  let step = 0;
  let cycle = 0;
  let position = 0;
  let lastWritten = -1;
  let frame = 0;
  let lastTime = 0;
  let animation = null;
  let interactionTimer;
  let interacting = false;
  let pointerActive = false;
  let visible = !('IntersectionObserver' in window);
  let hovered = false;
  let focused = false;
  let userPaused = false;
  let canLoop = false;
  const modulo = (value, divisor) => ((value % divisor) + divisor) % divisor;
  function makeCopy(card, index) {
   const copy = card.cloneNode(true);
   [copy, ...copy.querySelectorAll('*')].forEach(element => {
    [...element.attributes].forEach(attribute => {
     if (attribute.name === 'id' || attribute.name === 'name' || attribute.name.startsWith('data-') || ['for','aria-labelledby','aria-describedby','aria-controls'].includes(attribute.name)) element.removeAttribute(attribute.name);
    });
    if (element.matches('a,button,input,select,textarea,[tabindex]')) element.tabIndex = -1;
   });
   copy.querySelectorAll('script').forEach(element => element.remove());
   copy.dataset.carouselCopy = String(index);
   copy.setAttribute('aria-hidden', 'true');
   copy.inert = true;
   copies[index].push(copy);
   return copy;
  }
  for (let group = 0; group < 3; group++) {
   cards.forEach((card, index) => {
    const slot = document.createElement('div');
    slot.className = 'signature-cell';
    slot.append(group === 1 ? card : makeCopy(card, index));
    slots.push(slot);
   });
  }
  track.replaceChildren(...slots);
  track.classList.add('is-circular');
  function syncCopies() {
   cards.forEach((card, index) => {
    const button = card.querySelector('[data-save-style]');
    if (!button) return;
    copies[index].forEach(copy => {
     const target = copy.querySelector('.save-style');
     if (!target) return;
     ['aria-pressed','aria-label','title'].forEach(name => {
      const value = button.getAttribute(name);
      if (value === null) target.removeAttribute(name); else target.setAttribute(name, value);
     });
    });
   });
  }
  function update() {
   if (!step) return;
   const width = track.clientWidth;
   const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
   const cardWidth = step - gap;
   const left = track.scrollLeft;
   const shown = [];
   cards.forEach((card, index) => {
    const alternatives = [index, index + cards.length, index + cards.length * 2];
    const best = !canLoop ? index + cards.length : alternatives.reduce((selected, slotIndex) => Math.abs(slotIndex * step + cardWidth / 2 - left - width / 2) < Math.abs(selected * step + cardWidth / 2 - left - width / 2) ? slotIndex : selected);
    if (!pointerActive && !card.contains(document.activeElement) && card.parentElement !== slots[best]) {
     const former = card.parentElement;
     const copy = slots[best].firstElementChild;
     former.replaceChild(copy, card);
     slots[best].append(card);
    }
   });
   slots.forEach((slot, slotIndex) => {
    const x = (canLoop ? slotIndex : slotIndex - cards.length) * step - left;
    const overlap = slot.hidden ? 0 : Math.min(x + cardWidth, width) - Math.max(x, 0);
    const card = slot.firstElementChild;
    card.inert = overlap <= 1 && !card.contains(document.activeElement);
    if (!card.hasAttribute('data-carousel-copy')) {
     if (card.inert) card.setAttribute('aria-hidden', 'true'); else card.removeAttribute('aria-hidden');
    }
    if (overlap > Math.min(cardWidth * .3, width * .3)) shown.push(slotIndex % cards.length + 1);
   });
   const indices = [...new Set(shown)];
   if (indices.length) {
    const groups = [];
    indices.forEach(index => {
     const group = groups[groups.length - 1];
     if (group && index === group[group.length - 1] + 1) group.push(index); else groups.push([index]);
    });
    const styles = groups.map(group => group.length > 1 ? `${group[0]}–${group[group.length - 1]}` : String(group[0])).join(', ');
    const text = carousel.dataset.loopPositionTemplate
     ? carousel.dataset.loopPositionTemplate.replace('__STYLES__', styles).replace('__TOTAL__', cards.length)
     : carousel.dataset.positionTemplate.replace('__FIRST__', indices[0]).replace('__LAST__', indices[indices.length - 1]).replace('__TOTAL__', cards.length);
    if (status.textContent !== text) status.textContent = text;
   }
   const ratio = Math.min(1, width / cycle);
   progress.style.width = `${ratio * 100}%`;
   progress.style.marginLeft = `${modulo(left, cycle) / cycle * (1 - ratio) * 100}%`;
   previous.disabled = next.disabled = !canLoop;
  }
  function writePosition(force = false) {
   if (!cycle) return;
   if (!canLoop) { position = 0; lastWritten = 0; track.scrollLeft = 0; update(); return; }
   const nearEdge = position < step || position > cycle * 3 - track.clientWidth - step;
   if (!interacting || animation || force || nearEdge) {
    const normalized = cycle + modulo(position - cycle, cycle);
    const shift = normalized - position;
    position = normalized;
    if (animation) { animation.from += shift; animation.to += shift; }
   }
   lastWritten = position;
   track.scrollLeft = position;
   update();
  }
  const canRotate = () => canLoop && visible && !hovered && !focused && !interacting && !userPaused && !reduced.matches && !document.hidden && !document.querySelector('dialog[open]') && !carousel.closest('[inert]');
  function tick(time) {
   if (destroyed) return;
   frame = 0;
   const elapsed = lastTime ? Math.min(time - lastTime, 50) : 0;
   lastTime = time;
   if (animation) {
    animation.elapsed += elapsed;
    const fraction = Math.min(1, animation.elapsed / 360);
    position = animation.from + (animation.to - animation.from) * (1 - Math.pow(1 - fraction, 3));
    writePosition();
    if (fraction === 1) { animation = null; pauseForInteraction(); }
   } else if (canRotate()) {
    position += direction * elapsed * .026;
    writePosition();
   }
   if (animation || canRotate()) frame = requestAnimationFrame(tick); else lastTime = 0;
  }
  function syncRotation() {
   if (destroyed) return;
   const running = canRotate();
   carousel.dataset.autoplayState = running ? 'running' : 'paused';
   status.setAttribute('aria-live', running ? 'off' : 'polite');
   if (toggle) {
    toggle.hidden = !canLoop;
    toggle.disabled = reduced.matches;
    toggle.querySelector('[data-carousel-autoplay-label]').textContent = reduced.matches ? toggle.dataset.reducedLabel : userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
    toggle.setAttribute('aria-label', reduced.matches ? toggle.dataset.reducedLabel : userPaused ? toggle.dataset.playAria : toggle.dataset.pauseAria);
    toggle.querySelector('[data-carousel-autoplay-symbol]').textContent = reduced.matches || userPaused ? '▶' : 'Ⅱ';
   }
   if (running || animation) { if (!frame) frame = requestAnimationFrame(tick); }
   else { cancelAnimationFrame(frame); frame = 0; lastTime = 0; }
  }
  function pauseForInteraction() {
   interacting = true;
   clearTimeout(interactionTimer);
   syncRotation();
   if (!pointerActive) interactionTimer = setTimeout(() => {
    interacting = false;
    writePosition(true);
    syncRotation();
   }, 1200);
  }
  function move(amount) {
   if (!canLoop) return;
   pauseForInteraction();
   const from = position;
   const to = position + amount;
   if (reduced.matches) { animation = null; position = to; writePosition(true); }
   else animation = {from, to, elapsed:0};
   syncRotation();
  }
  listen(previous, 'click', () => move(-step));
  listen(next, 'click', () => move(step));
  toggle && listen(toggle, 'click', () => {
   userPaused = !userPaused;
   if (!userPaused) { focused = false; interacting = false; clearTimeout(interactionTimer); }
   syncRotation();
  });
  listen(carousel, 'pointerenter', event => { if (event.pointerType === 'mouse' && fineHover.matches) { hovered = true; syncRotation(); } });
  listen(carousel, 'pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; syncRotation(); } });
  listen(carousel, 'pointerdown', () => { focused = false; syncRotation(); }, {passive:true});
  listen(carousel, 'focusin', () => { focused = keyboardInput; syncRotation(); });
  listen(carousel, 'focusout', event => { if (!carousel.contains(event.relatedTarget)) { focused = false; update(); syncRotation(); } });
  listen(track, 'pointerdown', () => { pointerActive = true; animation = null; position = track.scrollLeft; pauseForInteraction(); }, {passive:true});
  const releasePointer = () => {
   if (!pointerActive) return;
   pointerActive = false;
   pauseForInteraction();
  };
  listen(window, 'pointerup', releasePointer, {passive:true});
  listen(window, 'pointercancel', releasePointer, {passive:true});
  listen(window, 'blur', releasePointer);
  listen(track, 'wheel', event => {
   if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) { animation = null; position = track.scrollLeft; pauseForInteraction(); }
  }, {passive:true});
  listen(track, 'keydown', event => {
   if (event.target !== track) return;
   focused = true;
   if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? step : -step); }
   if (event.key === 'Home' || event.key === 'End') {
    event.preventDefault();
    const target = event.key === 'Home' ? 0 : (cards.length - 1) * step;
    move(target - modulo(position, cycle));
   }
  });
  listen(track, 'mousedown', event => { if (event.target.closest('[data-carousel-copy]')) event.preventDefault(); });
  listen(track, 'click', event => {
   const copy = event.target.closest('[data-carousel-copy]');
   if (!copy || !event.target.closest('.save-style')) return;
   event.preventDefault();
   cards[Number(copy.dataset.carouselCopy)].querySelector('[data-save-style]')?.click();
   syncCopies();
  });
  listen(track, 'scroll', () => {
   if (Math.abs(track.scrollLeft - lastWritten) > 1) {
    position = track.scrollLeft;
    animation = null;
    if (interacting) pauseForInteraction();
   }
   update();
  }, {passive:true});
  const resize = () => {
   const phase = cycle && canLoop ? modulo(position, cycle) / step : 0;
   slots.forEach(slot => { slot.hidden = false; });
   const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
   step = slots[0].getBoundingClientRect().width + gap;
   cycle = step * cards.length;
   canLoop = cards.length > 1 && cycle - gap > track.clientWidth + 2;
   animation = null;
   slots.forEach((slot, index) => { slot.hidden = !canLoop && (index < cards.length || index >= cards.length * 2); });
   position = cycle + phase * step;
   writePosition(true);
   syncRotation();
  };
  listen(window, 'resize', resize, {passive:true});
  listen(document, 'visibilitychange', () => {
   if (document.hidden) { releasePointer(); animation = null; }
   syncRotation();
  });
  listen(document, 'ynd:overlay', syncRotation);
  listen(reduced, 'change', () => { animation = null; syncRotation(); });
  listen(fineHover, 'change', () => { if (!fineHover.matches) hovered = false; syncRotation(); });
  if ('ResizeObserver' in window) observe(ResizeObserver, track, resize);
  if ('IntersectionObserver' in window) {
   const observer = new IntersectionObserver(entries => {
   if (destroyed) return;
   visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
   if (!visible) animation = null;
   syncRotation();
   }, {threshold:[0,.15]});
   observer.observe(carousel);
   cleanups.push(() => observer.disconnect());
  }
  if ('MutationObserver' in window) {
   const main = carousel.closest('main');
   if (main) observe(MutationObserver, main, syncRotation, {attributes:true,attributeFilter:['inert']});
   cards.forEach(card => observe(MutationObserver, card, syncCopies, {subtree:true,attributes:true,attributeFilter:['aria-pressed','aria-label','title']}));
  }
  instances.set(carousel, () => {
   destroyed = true;
   cancelAnimationFrame(frame);
   clearTimeout(interactionTimer);
   animation = null;
   cleanups.forEach(cleanup => cleanup());
   // Keep the original nodes and card order so the same section can initialize again.
   track.replaceChildren(...cards);
   track.classList.remove('is-circular');
   cards.forEach((card, index) => {
    card.inert = originalState[index].inert;
    if (originalState[index].hidden === null) card.removeAttribute('aria-hidden');
    else card.setAttribute('aria-hidden', originalState[index].hidden);
   });
   delete carousel.dataset.autoplayState;
   instances.delete(carousel);
  });
  syncCopies();
  resize();
 }
 function initializeWithin(root) {
  instances.forEach((dispose, carousel) => { if (!carousel.isConnected) dispose(); });
  if (root.matches?.('[data-signature-carousel]')) initialize(root);
  root.querySelectorAll('[data-signature-carousel]').forEach(initialize);
 }
 document.addEventListener('shopify:section:unload', event => {
  instances.forEach((dispose, carousel) => {
   if (event.target === carousel || event.target.contains(carousel)) dispose();
  });
 });
 document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
 initializeWithin(document);
})();
